export const DIETARY_PREFERENCES_BASIC = {
  MIX: 'Mix',
  VEGETARIAN: 'Vega',
}

export const DIETARY_PREFERENCES = {
  ...DIETARY_PREFERENCES_BASIC,
  VEGAN: 'Vegan',
}
